export default __webpack_public_path__ + "static/media/Final.jpg.a8cfcf4d.jpg";